import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {RESETAR_SENHA_USUARIO_PLATAFORMA_WEB} from '../types';
import {URL} from '../../util/ambienteActions';

export default function resetarSenhaUsuarioPlataformaWeb(codigo) {
    const url = `${URL}/usuarios/plataforma-web/${codigo}/resetar-senha`;

    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: RESETAR_SENHA_USUARIO_PLATAFORMA_WEB,
            payload: response
        })
    );
}
